import React, { useEffect } from "react";

interface SEOProps {
  title?: string;
  description?: string;
  image?: string;
  url?: string;
}

const SEO: React.FC<SEOProps> = ({
  title = "PWC Profiles | Kemper Profiles, ToneX Models & NAM Skins",
  description = "High-quality Kemper profiles, ToneX models, and photorealistic NAM skins meticulously crafted to capture iconic album guitar tones.",
  image = "https://www.pwc-profiles.com/images/hero_pwc.webp",
  url = "https://www.pwc-profiles.com/",
}) => {
  useEffect(() => {
    document.title = title;

    const updateMetaTag = (selector: string, content: string) => {
      const element = document.querySelector(selector);
      if (element) {
        element.setAttribute("content", content);
      }
    };

    updateMetaTag('meta[name="description"]', description);
    updateMetaTag('meta[property="og:title"]', title);
    updateMetaTag('meta[property="og:description"]', description);
    updateMetaTag('meta[property="og:image"]', image);
    updateMetaTag('meta[property="og:url"]', url);
    updateMetaTag('meta[name="twitter:title"]', title);
    updateMetaTag('meta[name="twitter:description"]', description);
    updateMetaTag('meta[name="twitter:image"]', image);
  }, [title, description, image, url]);

  return null;
};

export default SEO;
